module.exports = __webpack_public_path__ + "static/Lamentum1-ae8139bac60c978cecba4d77e318e827.webp";